import { ElSelect, ElOption } from 'element-plus';
import { UPDATE_MODEL_EVENT, CHANGE_EVENT } from 'element-plus/lib/constants/index';
import { defineComponent, reactive, ref, computed, watch, onMounted, resolveComponent, openBlock, createElementBlock, Fragment, createCommentVNode, createBlock, normalizeClass, withCtx, createTextVNode, toDisplayString, mergeProps, renderList, renderSlot } from 'vue';
import { TEllipsisText } from '../../ellipsis-text/index2.js';
import { isValidComponentSize } from 'element-plus/lib/utils/index';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "TSelect",
  props: {
    name: String,
    id: String,
    modelValue: [Array, String, Number, Boolean, Object],
    autocomplete: {
      type: String,
      default: "off"
    },
    automaticDropdown: Boolean,
    size: {
      type: String,
      validator: isValidComponentSize
    },
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: {
      type: String,
      default: ""
    },
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: "value"
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    clearIcon: {
      type: String,
      default: "el-icon-circle-close"
    },
    options: {
      type: [Array, Function],
      default: () => []
    },
    tabindex: {
      type: Number,
      default: void 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TEllipsisText,
    ElSelect,
    ElOption
  },
  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT, "remove-tag", "clear", "visible-change", "focus", "blur"],
  setup(props) {
    const reactiveProps = reactive(props);
    const elSelectRef = ref(null);
    const selectOptions = ref(reactiveProps.options instanceof Array ? reactiveProps.options : []);
    const elSelectProps = computed(() => {
      const extendsPropsKey = ["options"];
      const result = {};
      Object.keys(reactiveProps).forEach((key) => {
        if (!(key in extendsPropsKey)) {
          result[key] = reactiveProps[key];
        }
      });
      return result;
    });
    const getSelectedLabel = () => {
      const target = selectOptions.value.find((item) => item.value === reactiveProps.modelValue);
      return target ? target.label : "-";
    };
    watch(() => reactiveProps.options, (newVal) => {
      if (newVal instanceof Array) {
        selectOptions.value = newVal;
      }
    });
    watch([() => reactiveProps.tabindex, () => elSelectRef.value], () => {
      if (elSelectRef.value) {
        const selectInputEl = elSelectRef.value.$el.querySelector("input");
        if (reactiveProps.tabindex !== void 0) {
          selectInputEl.setAttribute("tabindex", reactiveProps.tabindex.toString());
        } else {
          selectInputEl.removeAttribute("tabindex");
        }
      }
    }, {
      immediate: true
    });
    onMounted(async () => {
      if (typeof reactiveProps.options === "function") {
        const res = await reactiveProps.options();
        if (res instanceof Array) {
          selectOptions.value = res;
        }
      }
    });
    return {
      elSelectRef,
      elSelectProps,
      selectOptions,
      getSelectedLabel
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_ellipsis_text = resolveComponent("t-ellipsis-text");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  return openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode(" eslint-disable "),
    _ctx.readonly ? (openBlock(), createBlock(_component_t_ellipsis_text, {
      key: 0,
      tag: "span",
      class: normalizeClass(["t-select__readonly-text", `el-input--${_ctx.size || "medium"}`, "el-input__inner"])
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.getSelectedLabel()), 1)
      ]),
      _: 1
    }, 8, ["class"])) : (openBlock(), createBlock(_component_el_select, mergeProps({
      key: 1,
      ref: "elSelectRef"
    }, _ctx.elSelectProps, {
      onRemoveTag: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("remove-tag", $event)),
      onClear: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("clear", $event)),
      onVisibleChange: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("visible-change", $event)),
      onFocus: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focus", $event)),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.$emit("update:modelValue", $event)),
      onChange: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("change", $event))
    }), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectOptions || [], (option) => {
          return openBlock(), createBlock(_component_el_option, {
            key: option.value,
            label: option.label,
            disabled: option.disabled,
            value: option.value
          }, null, 8, ["label", "disabled", "value"]);
        }), 128)),
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16))
  ], 2112);
}
var Select = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/select/src/select.vue"]]);

export { Select as default };
//# sourceMappingURL=select.vue2.js.map
